import { Component, ViewEncapsulation, Input, OnInit, forwardRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/**
 * å¼å³
 * 
 * <example-url>https://stackblitz.com/edit/np-switch-sample?embed=1&file=src/app/app.component.html</example-url>
 */
@Component({
  selector: `np-switch`,
  templateUrl: 'switch.html',
  styleUrls: ['switch.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpSwitch),
      multi: true,
    }]
})

export class NpSwitch implements OnInit, ControlValueAccessor {
  val: string | boolean;
  /**æ ç­¾ */
  @Input() label: string;
  /**å¼å³ä¸ºæå¼ç¶ææ¶çå¼ï¼é»è®¤ä¸ºtrue */
  @Input() trueValue: any;
  /**å¼å³ä¸ºå³é­ç¶ææ¶çå¼ï¼é»è®¤ä¸ºfalse */
  @Input() falseValue: any;
  /**æ¯å¦ç¦ç¨ */
  @Input() isDisabled = false;
  /**æ¯å¦å¿å¡« - å¿å¡«åæçº¢è²*å·å¨æ ç­¾åé¢ï¼å¦åæ²¡æ */
  @Input() isRequired = false;
  /**æ ç­¾çæ¹åï¼leftå¨å¼å³å·¦æ¹ï¼rightå¨å¼å³å³æ¹ */
  @Input() direction: 'left' | 'right' = "left";
  /**å¼å³ç¶æåçæ¹åæ¶è§¦åäºä»¶ */
  @Output() inputModelChange = new EventEmitter();
  get ischecked(): boolean {
    if (this.trueValue || this.falseValue) {
      if (this.val === this.trueValue) {
        return true;
      }
      if (this.val === this.falseValue) {
        return false;
      }
    } else {
      return this.val ? true : false;
    }
  }
  private emitChange: Function = (_: any) => { };

  constructor(private cdf: ChangeDetectorRef) { }

  ngOnInit() {
    // è½¬æ¢ä¸ä¼ å¥çå¼
  }

  onChange(e: any) {
    if (this.isDisabled) {
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    if (this.ischecked) {
      this.val = this.falseValue || false;
      this.emitChange(this.val);
      this.inputModelChange.emit(this.val);
      return;

    }
    if (!this.ischecked) {
      this.val = this.trueValue || true;
      this.emitChange(this.val);
      this.inputModelChange.emit(this.val);
      return;
    }
  }

  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.val = obj;
      this.emitChange(this.val);
    }
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void { }
}


